<template>
  <div>
    <div v-if="auditData !== null">
      <div class="d-flex flex-wrap">
        <div class="card maadi-dark-card flex-fill d-flex m-1 p-1 align-items-center justify-content-center flex-wrap" v-for="violatingMember in violatingMembers" :key="violatingMember.selector"  v-on:click="setViolatingDataset(violatingMember)">
          <span style="font-size: 1em; text-transform: uppercase"> {{ violatingMember.title }} </span>
          <binary-pie-chart  v-bind:data="{selector: violatingMember.selector, dataSet: [violatingMember.dataset.length, violatingMember.comparatorCount - violatingMember.dataset.length], colors: ['#C1272D', '#30455F']}"></binary-pie-chart>
          <div class="d-flex align-items-center flex-fill">
            {{ violatingMember.dataset.length }} / {{ violatingMember.comparatorCount }}
          </div>
          <div v-if="violatingMember.explanation !== null" class="d-flex align-items-center flex-fill" style="font-size: 0.7em;">
            {{ violatingMember.explanation }}
          </div>
        </div>
      </div>
      <span id="violating-member"></span>
      <div class="card maadi-dark-card m-1" v-if="selectedViolatingDataset !== null" >
        <div class="card-body">
          <div class="text-center mb-3" style="text-transform: uppercase; font-size: 1.5em;">
            {{ selectedViolatingDataset.title }}
          </div>
          <div style="max-height: 250px; overflow-y: auto">
            <div v-for="organization in selectedViolatingDataset.dataset" :key="organization.account_id" class="d-flex m-1 p-2" style="border: 1px solid #3E597A">
              <a style="font-size: 1.3em;" :href="'https://secure.medicalalley.org/admin/accounts/' + organization.account_id + '/memberships'" target="_blank">
                {{ organization.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BinaryPieChart from '../../tools/charts/BinaryPieChart'
import MemberAPI from '../../../api/members'

export default {
  name: '',
  components: {BinaryPieChart},
  data: function () {
    return {
      auditData: null,
      selectedViolatingDataset: null
    }
  },
  methods: {
    setViolatingDataset (violatingDataset) {
      this.selectedViolatingDataset = violatingDataset
      document.getElementById('violating-member').scrollIntoView()
    }
  },
  computed: {
    members () {
      return this.auditData.filter((x) => x.is_current_member === 1)
    },
    nonmembers () {
      return this.auditData.filter((x) => x.is_current_member === 0)
    },
    violatingMembers () {
      return [
        {
          dataset: this.members.filter((x) => x.current_year_drop === 1),
          comparatorCount: this.members.length,
          selector: 'current-year-drop',
          title: 'Active members who have dropped their current membership',
          explanation: null
        },
        {
          dataset: this.members.filter((x) => x.previous_year_drop === 1),
          comparatorCount: this.members.length,
          selector: 'previous-year-drop',
          title: 'Active members who dropped their previous year\'s membership',
          explanation: null
        },
        {
          dataset: this.members.filter((x) => x.multi_year_membership === 1),
          comparatorCount: this.members.length,
          selector: 'multi-year-membership',
          title: 'active members with single memberships lasting more than one year',
          explanation: null
        },
        {
          dataset: this.members.filter((x) => x.has_inaccurate_join === 1),
          comparatorCount: this.members.length,
          selector: 'inaccurate-join-membership',
          title: 'Members with inaccurately marked at \'JOIN\'',
          explanation: null
        },
        {
          dataset: this.members.filter((x) => x.has_grace_period === 1),
          comparatorCount: this.members.length,
          selector: 'grace-period-membership',
          title: 'Active members with grace period membership records',
          explanation: 'Grace period memberships should be deleted after a member has renewed or dropped.'
        },
        {
          dataset: this.nonmembers.filter((x) => x.previous_year_drop === 0),
          comparatorCount: this.nonmembers.length,
          selector: 'non-members-without-drops',
          title: 'Non-members without drop records.',
          explanation: 'Members who did not renew for current year but are not listed as drops.'
        },
        {
          dataset: this.nonmembers.filter((x) => x.previous_year_drop === 1 && x.has_grace_period === 1),
          comparatorCount: this.nonmembers.length,
          selector: 'non-members-with-grace-periods',
          title: 'Non-members with grace period records.',
          explanation: 'Members who dropped but still have grace period memberships.'
        }
      ]
    }
  },
  mounted () {
    MemberAPI.getMemberAudit().then(
      response => {
        this.auditData = response.data.data
      }
    )
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/auditing/Index.vue